module.exports = __webpack_public_path__ + "static/img/verify_2x.a7267ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/verify_2x.png
// module id = XKeb
// module chunks = 1